<script setup lang="ts">
import useCurrentURL from '@/composables/useCurrentURL';
import { useHead, useSeoMeta } from '#app';

const { createUrl, currentUrl } = useCurrentURL();

useHead({
  link: [
    { rel: 'icon', type: 'image/png', href: '/favicon-48x48.png', sizes: '48x48' },
    { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
    { rel: 'shortcut icon', href: '/favicon.ico' },
    { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
    { rel: 'manifest', href: '/site.webmanifest' },
  ],
});

useSeoMeta({
  title: 'Open Methane',
  ogTitle: 'Open Methane',
  description: 'An Open Platform for Understanding Australia\'s Methane Emissions.',
  ogDescription: 'An Open Platform for Understanding Australia\'s Methane Emissions.',
  ogSiteName: 'Open Methane',
  ogType: 'website',
  ogImage: createUrl('/img/social-card-1200x630.jpg'),
  ogUrl: currentUrl(),
  twitterCard: 'summary_large_image',
});
</script>

<template>
  <NuxtPage />
</template>
